// extracted by mini-css-extract-plugin
export default {"departments":"KF-z","departmentHeading":"LF-z","departmentSection":"MF-z","departmentName":"NF-z","departmentLink":"OF-z","expandIcon":"PF-z"};